import React from "react";
import MDButton from "materialDashboard/components/MDButton";
import {useFeedbackTools} from "../FeedbackTools";
import {useTranslation} from "react-i18next";

const MDDeleteButton = ({onDelete, buttonText, dialogTitle, dialogMessage, variant="outlined", ...rest}) => {
    const {t} = useTranslation('components');
    const [loading, setLoading] = React.useState(false);
    const {askConfirmation} = useFeedbackTools();

    const handleDelete = async () => {
        askConfirmation({
            title: dialogTitle,
            description: dialogMessage,
            confirmationText: t('MDDeleteButton.buttonText'),

            onConfirm: async () => {
                setLoading(true);
                try {
                    await onDelete();
                } catch (e) {
                    setLoading(false);
                    throw e;
                }
            }
        });
    }

    return <MDButton onClick={handleDelete} disabled={loading} color='error' variant={variant} {...rest}>
        {buttonText ?? t('MDDeleteButton.buttonText')}
    </MDButton>
}


export default MDDeleteButton;
